<template>
  <div
    class="fixed inset-0 overflow-auto z-40 backdrop-blur-sm"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
    v-if="show"
  >
    <transition
      appear
      enter-from-class="opacity-0"
      enter-active-class="ease-out duration-300"
      enter-to-class="opacity-100"
      leave-from-class="opacity-100"
      leave-active-class="ease-in duration-200"
      leave-to-class="opacity-0"
    >
      <div
        class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"
      ></div>
    </transition>
    <div class="fixed z-10 inset-0 overflow-y-auto">
      <div
        class="
          flex
          items-center
          justify-center
          h-full
          sm:min-h-full
          p-0
          sm:p-4
          text-center
        "
      >
        <transition
          appear
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-active-class="ease-out duration-300"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              relative
              bg-gray-900
              border-2 border-gray-800
              rounded-lg
              text-left
              shadow-2xl
              transform
              transition-all
              my-8
              max-w-lg
              w-full
              py-5
              px-10
              pb-10
              h-full
              sm:h-fit
              mt-20
            "
          >
            <div class="space-y-5">
              <!-- Header -->
              <div>
                <h1 class="text-gray-200 text-lg font-semibold">
                  Change your password
                </h1>
              </div>

              <!-- Form -->
              <div class="flex flex-col space-y-5">
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-200"
                    >Current password</label
                  >
                  <div class="mt-1">
                    <input
                      v-model="currentPassword"
                      id="currentPassword"
                      name="currentPassword"
                      type="password"
                      autocomplete="off"
                      class="
                        text-gray-100
                        focus:ring-gray-600 focus:border-gray-600
                        bg-gray-900
                        shadow-sm
                        block
                        w-full
                        sm:text-sm
                        border-gray-700
                        rounded-md
                      "
                      placeholder="********"
                    />
                  </div>
                </div>
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-200"
                    >New password</label
                  >
                  <div class="mt-1">
                    <input
                      v-model="newPassword"
                      id="newPassword"
                      name="newPassword"
                      type="password"
                      autocomplete="off"
                      class="
                        text-gray-100
                        focus:ring-gray-600 focus:border-gray-600
                        bg-gray-900
                        shadow-sm
                        block
                        w-full
                        sm:text-sm
                        border-gray-700
                        rounded-md
                      "
                      placeholder=""
                    />
                  </div>
                </div>
                <div>
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-200"
                    >Confirm new password</label
                  >
                  <div class="mt-1">
                    <input
                      v-model="newPasswordConfirm"
                      id="newPasswordConfirm"
                      name="newPasswordConfirm"
                      type="password"
                      autocomplete="off"
                      class="
                        text-gray-100
                        focus:ring-gray-600 focus:border-gray-600
                        bg-gray-900
                        shadow-sm
                        block
                        w-full
                        sm:text-sm
                        border-gray-700
                        rounded-md
                      "
                      placeholder=""
                    />
                  </div>
                </div>
                <div class="flex flex-row justify-center space-x-5 pt-5">
                  <button
                    @click="show = false"
                    class="
                      min-w-[100px]
                      bg-gray-600
                      py-2
                      px-3
                      text-white
                      rounded-md
                      font-semibold
                      text-sm
                    "
                  >
                    Cancel
                  </button>
                  <button
                    @click="changePassword"
                    class="
                      min-w-[100px]
                      bg-red-600
                      py-2
                      px-3
                      text-white
                      rounded-md
                      font-semibold
                      text-sm
                    "
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>


<script setup>
import { onMounted, ref } from "vue";
import { auth } from "../../firebase";
import {
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";

import emitter from "../../utils/emitter.js";

//Props
const show = ref(false);

//Form data
const newPassword = ref();
const newPasswordConfirm = ref();
const currentPassword = ref();

const changePassword = () => {
  if (newPassword.value !== newPasswordConfirm.value) {
    /** Throw error */
    emitter.emit("showNotification", {
      title: "Ups!",
      content: "The new password does not match",
      type: "error",
      show: true,
      timeout: true,
    });
    return false;
  }

  /** Get user */
  const user = auth.currentUser;

  const credential = EmailAuthProvider.credential(
    user.email,
    currentPassword.value
  );

  /** First reauthenticate user */
  reauthenticateWithCredential(user, credential)
    .then(() => {
      /** success */
      /** Update password */
      updatePassword(user, newPassword.value)
        .then(() => {
          /** Password changed successfully */
          //Emit notification
          emitter.emit("showNotification", {
            title: "Success!",
            content: "Your password was changed successfully",
            type: "success",
            show: true,
            timeout: true,
          });

          //** Close modal */
          show.value = false;

        })
        .catch((error) => {
          emitter.emit("showNotification", {
            title: "Ups!",
            content: error,
            type: "error",
            show: true,
            timeout: true,
          });
        });
    })
    .catch((error) => {
      emitter.emit("showNotification", {
        title: "Ups!",
        content: error,
        type: "error",
        show: true,
        timeout: true,
      });
    });
};

//** Show dialog with emitter */
emitter.on("showPasswordChange", (payload) => {
  show.value = payload.show;
});

onMounted(() => {});
</script>

